import React from 'react';
import { Box, BoxProps, Container, Heading } from '@hover/blueprint';
import Slider from 'react-slick';
import { StaticImage } from 'gatsby-plugin-image';
import styled from '@emotion/styled';

const settings = {
  dots: false,
  infinite: true,
  dragControls: false,
  draggable: false,
  swipeToSlide: false,
  speed: 2000,
  autoplaySpeed: 2000,
  slidesToShow: 5,
  autoplay: true,
  responsive: [
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1152,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 5,
      },
    },
  ],
};

interface Props extends BoxProps {}

const Slide: React.FC<Props> = ({ children, ...restProps }) => (
  <Box {...restProps} mx="auto" w="auto" px="auto">
    {children}
  </Box>
);

const StyledSlider = styled(Slider)`
  .slick-track {
    display: flex;
  }

  .slick-slide {
    div {
      div {
        display: flex !important;
        justify-content: center;
      }
    }
  }
`;

const TrustedByContractorsLogosSlider: React.FC = () => (
  <Container
    maxW="1200px"
    mt={1000}
    overflow="hidden"
    flexDir="column"
    alignItems="center"
  >
    <Container maxW="5xl" overflow="hidden" mb="52px">
      <Box flexDir="column" alignItems="center">
        <Heading
          as="h2"
          maxW="5xl"
          size={{ base: 500, tablet: 700 }}
          textAlign="center"
          isLight
          style={{ marginBottom: 24 }}
        >
          Chosen by the names you trust in home protection and restoration
        </Heading>
        <Heading
          as="p"
          size={{ base: 300, tablet: 500 }}
          textAlign="center"
          isDisplay
          style={{ marginBottom: 0 }}
        >
          HOVER isn’t just trusted by your contractor, we’re trusted by a whole
          network of contractors. Like these right here.
        </Heading>
      </Box>
    </Container>
    <Box
      overflow="visible"
      display="block"
      width="100%"
      height="100px"
      mb="56px"
    >
      <StyledSlider {...settings}>
        <Slide>
          <StaticImage
            style={{ marginTop: 44 }}
            placeholder="blurred"
            width={175}
            height={24}
            src="../../assets/images/state_farm_logo_1.png"
            alt="state farm logo"
          />
        </Slide>
        <Slide w="148px">
          <StaticImage
            height={90}
            width={148}
            placeholder="blurred"
            objectFit="contain"
            src="../../assets/images/logo_nationWide.png"
            alt="gaf logo"
          />
        </Slide>
        <Slide h="100px" pb={500}>
          <StaticImage
            style={{ marginTop: 30 }}
            placeholder="blurred"
            width={124}
            height={38}
            objectFit="contain"
            src="../../assets/images/amfam_logo.png"
            alt="srs logo"
          />
        </Slide>
        <Slide h="100px" pb={600}>
          <StaticImage
            style={{ marginTop: 24 }}
            placeholder="blurred"
            width={162}
            height={38}
            objectFit="contain"
            src="../../assets/images/travelers_vector_logo_red.png"
            alt="travelers logo"
          />
        </Slide>
        <Slide h="100px">
          <StaticImage
            style={{ marginTop: 14 }}
            placeholder="blurred"
            width={67}
            height={67}
            objectFit="contain"
            src="../../assets/images/shelter_insurance.png"
            alt="owens corning logo"
          />
        </Slide>
        <Slide h="100px" pb={200}>
          <StaticImage
            style={{ marginTop: 28 }}
            placeholder="blurred"
            width={134}
            objectFit="contain"
            height={59}
            src="../../assets/images/cincinatti_logo.png"
            alt="bacon roofing supply logo"
          />
        </Slide>
      </StyledSlider>
    </Box>
  </Container>
);

export default TrustedByContractorsLogosSlider;
